import { useEffect } from 'react'
import { useParams, useNavigate, useLocation, Outlet } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

const SUPPORTED_LANGS = ['en', 'he', 'hi', 'id', 'ms']

export function LanguageLayout() {
  const { lang } = useParams<{ lang: string }>()
  const { i18n } = useTranslation()
  const navigate = useNavigate()
  const location = useLocation()

  useEffect(() => {
    if (!lang || !SUPPORTED_LANGS.includes(lang)) {
      // Invalid language prefix — redirect with correct lang, preserving full path
      const detectedLang = i18n.language || 'he'
      navigate(`/${detectedLang}${location.pathname}${location.search}${location.hash}`, { replace: true })
      return
    }
    if (i18n.language !== lang) {
      i18n.changeLanguage(lang)
    }
  }, [lang, i18n, navigate, location])

  if (!lang || !SUPPORTED_LANGS.includes(lang)) {
    return null // will redirect
  }

  return <Outlet />
}

export function LanguageRedirect() {
  const navigate = useNavigate()
  const location = useLocation()
  const { i18n } = useTranslation()

  useEffect(() => {
    const lang = i18n.language || 'he'
    navigate(`/${lang}${location.search}${location.hash}`, { replace: true })
  }, [])

  return null
}

/**
 * Redirect any path without a valid lang prefix to the correct lang.
 * Used as a catch-all to handle old bookmarks like /create → /he/create
 */
export function CatchAllRedirect() {
  const navigate = useNavigate()
  const location = useLocation()
  const { i18n } = useTranslation()

  useEffect(() => {
    const lang = i18n.language || 'he'
    navigate(`/${lang}${location.pathname}${location.search}${location.hash}`, { replace: true })
  }, [])

  return null
}
